module.exports = __webpack_public_path__ + "1143d607f90e16dd3664aabcb6e1c8d1.svg";